import React from 'react';
import { queries } from '../../../graphql/graphql';
import PaginatedAdminList, { ListItem } from '../../../components/containers/PaginatedAdminList';
import { Plan } from '../../../components/Plans/AdminViewPlan';
import { IPlan } from '../../../types/plans';

const PlanWrapper: React.FC<{
  item: ListItem;
  prefix: string;
  roles?: string[];
}> = ({ item, roles }) => {
  return <Plan item={item as unknown as IPlan} roles={roles} />;
};

const ListPlans: React.FC = () => {
  return (
    <PaginatedAdminList
      prefix="plan"
      query={queries.plans.PLANS}
      inline={true}
      editable={true}
      canCreate={true}
      adminView={true}
      CustomCard={PlanWrapper}
      defaultPageSize={10}
    />
  );
};

export default ListPlans;
